import { TableToolbarButton } from '@shared/interfaces/table-toolbar.interface';

/**
 * Generates the standard toolbar buttons (Bulk Delete, Export) used across most tables.
 * Includes reactive logic to change the "Bulk Delete" button to a danger variant
 * when multiple rows are selected.
 *
 * @param selectionCount - Number of currently selected rows.
 * @returns Array of standard toolbar button configurations.
 */
export function getStandardToolbarButtons(selectionCount: number): TableToolbarButton[] {
    return [
        {
            buttonName: 'Bulk Delete',
            icon: 'delete',
            variant: selectionCount > 2 ? 'danger' : 'secondary',
        },
        {
            buttonName: 'Export',
            icon: 'export',
            variant: 'accent',
        },
    ];
}

/**
 * Determines which data should be exported based on the current user selection.
 * If data is selected, returns only the selection. Otherwise, returns all data.
 *
 * @param selectedRows - Array of user-selected rows.
 * @param allData - Array containing all data currently in the table.
 * @returns The dataset to be exported.
 */
export function getExportData<T>(selectedRows: T[], allData: T[]): T[] {
    return selectedRows.length > 0 ? selectedRows : allData;
}
